import { postFormData } from "@/shared/api";

/** B2B-лид: заявка компании на выкуп техники со списком устройств */
export interface B2bLead {
    calcApiToken: string;
    companyName: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    locale: string;
    countryCode: string;
    file: File;
    brand: string;
    model: string;
    grade: string;
    price: number | null;
}

/** Поля лида про выбранное устройство */
export type B2bLeadDevice = Pick<B2bLead, "brand" | "model" | "grade" | "price">;

/** Ответ API лидов. status 0 - лид не создан, причина в message */
interface CreateB2bLeadResponse {
    status: number;
    message?: string;
}

/** Создать B2B-лид со списком техники компании */
export async function apiCreateB2bLead(lead: B2bLead): Promise<void> {
    const body = new FormData();

    body.append("calc_api_token", lead.calcApiToken);
    body.append("company_name", lead.companyName);
    body.append("first_name", lead.firstName);
    body.append("last_name", lead.lastName);
    body.append("email", lead.email);
    body.append("locale", lead.locale);
    body.append("files[]", lead.file);

    if (lead.phone) body.append("phone", lead.phone);
    if (lead.countryCode) body.append("country_code", lead.countryCode);

    if (lead.brand) body.append("brand", lead.brand);
    if (lead.model) body.append("model", lead.model);
    if (lead.grade) body.append("grade", lead.grade);
    if (lead.price !== null) body.append("price", String(lead.price));

    const response = await postFormData<CreateB2bLeadResponse>(
        `${import.meta.env.VITE_B2B_LEADS_API_HOST}/api/b2b-leads`,
        body,
    );

    // The API reports a rejected lead with HTTP 200, so the error is in the body
    if (response.status === 0) {
        throw new Error(`b2b lead is not created: ${response.message ?? "no message"}`);
    }
}
